import {
  Button,
  Form,
  Typography,
  TYPOGRAPHY_SIZE,
} from '@thinknet-gmbh/platform-common-ui';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { useRouteQuery } from 'src/common/helpers';
import { usePartialEmployeeUpdate } from 'src/hooks/employees/partial-employee-update.hook';
import { PaymentAndInsuranceFields } from 'src/components/employee/payment-and-insurance/payment-and-insurance-fields';

import { IPaymentAndInsurance } from 'src/components/employee/employee.interfaces';
import { EditFormWrapper } from '../../../employee-details.styles';

const PaymentAndInsuranceEdit = ({
  onCancel,
  initialValues,
}: {
  onCancel: () => void;
  initialValues: IPaymentAndInsurance;
}) => {
  const { t } = useTranslation(['employee', 'common']);

  const query = useRouteQuery();
  const _id: string = query.get('id') || '';

  const [form] = Form.useForm();

  const partialEmployeeUpdate = usePartialEmployeeUpdate({ onSuccess: onCancel });

  const onFinish = (values: any) => {
    partialEmployeeUpdate({
      variables: {
        payload: {
          _id: _id,
          ...values,
        },
      },
    });
  };

  return (
    <Form
      layout="vertical"
      onFinish={onFinish}
      initialValues={{
        paymentAndInsurance: {
          ...initialValues,
          visaExpirationDate: initialValues?.visaExpirationDate
            ? moment(initialValues.visaExpirationDate)
            : null,
          workPermissionExpireDate: initialValues?.workPermissionExpireDate
            ? moment(initialValues.workPermissionExpireDate)
            : null,
          certificateOfStudyExpireDate: initialValues?.certificateOfStudyExpireDate
            ? moment(initialValues.certificateOfStudyExpireDate)
            : null,
          residencePermissionExpireDate: initialValues?.residencePermissionExpireDate
            ? moment(initialValues.residencePermissionExpireDate)
            : null,
        },
      }}
    >
      <EditFormWrapper>
        <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
          {t('employee:paymentAndInsurance.labels.headerTitle')}
        </Typography>
        <Button type="primary" htmlType="submit">
          {t('common:buttons.save')}
        </Button>
      </EditFormWrapper>
      <PaymentAndInsuranceFields
        isEdit
        form={form}
        switcherDefaultData={{
          workPermissionNeeded: initialValues?.workPermissionNeeded,
          hasCertificateOfStudy: initialValues?.hasCertificateOfStudy,
          residencePermissionNeeded: initialValues?.residencePermissionNeeded,
        }}
      />
    </Form>
  );
};

export default PaymentAndInsuranceEdit;
